export const qrTemplates = [
  {
    id: 'restaurant',
    name: 'Restaurant Menu',
    category: 'Food & Beverage',
    description: 'Perfect for digital menus and table ordering',
    icon: '🍽️',
    customization: {
      fgColor: '#7c2d12',
      bgColor: '#fff7ed',
    },
    suggestedType: 'url',
    placeholder: 'https://yourmenu.com'
  },
  {
    id: 'retail',
    name: 'Retail Store',
    category: 'Retail',
    description: 'Product info, promotions, and loyalty programs',
    icon: '🛍️',
    customization: {
      fgColor: '#be123c',
      bgColor: '#fdf2f8',
    },
    suggestedType: 'url',
    placeholder: 'https://yourstore.com/offers'
  },
  {
    id: 'realestate',
    name: 'Real Estate',
    category: 'Real Estate',
    description: 'Property listings and virtual tours',
    icon: '🏠',
    customization: {
      fgColor: '#0c4a6e',
      bgColor: '#f0f9ff',
    },
    suggestedType: 'url',
    placeholder: 'https://propertylisting.com'
  },
  {
    id: 'events',
    name: 'Event Ticket',
    category: 'Events',
    description: 'Event details, tickets, and registration',
    icon: '🎟️',
    customization: {
      fgColor: '#6b21a8',
      bgColor: '#faf5ff',
    },
    suggestedType: 'url',
    placeholder: 'https://yourevent.com/register'
  },
  {
    id: 'business',
    name: 'Business Card',
    category: 'Professional',
    description: 'Contact info and professional profile',
    icon: '💼',
    customization: {
      fgColor: '#0f172a',
      bgColor: '#ffffff',
    },
    suggestedType: 'content',
    placeholder: 'Name: John Doe\nPhone: +357 99 123456\nEmail: john@example.com'
  },
  {
    id: 'wifi',
    name: 'WiFi Access',
    category: 'Hospitality',
    description: 'Guest WiFi credentials and connection',
    icon: '📶',
    customization: {
      fgColor: '#065f46',
      bgColor: '#f0fdf4',
    },
    suggestedType: 'content',
    placeholder: 'WiFi: GuestNetwork\nPassword: welcome123'
  },
  {
    id: 'social',
    name: 'Social Media',
    category: 'Marketing',
    description: 'Link to social profiles and campaigns',
    icon: '📱',
    customization: {
      fgColor: '#1e40af',
      bgColor: '#eff6ff',
    },
    suggestedType: 'url',
    placeholder: 'https://instagram.com/yourbrand'
  },
  {
    id: 'hotel',
    name: 'Hotel Services',
    category: 'Hospitality',
    description: 'Room service, amenities, and concierge',
    icon: '🏨',
    customization: {
      fgColor: '#92400e',
      bgColor: '#fefce8',
    },
    suggestedType: 'url',
    placeholder: 'https://hotelservices.com/menu'
  },
  {
    id: 'fitness',
    name: 'Fitness Center',
    category: 'Health & Wellness',
    description: 'Class schedules and membership info',
    icon: '💪',
    customization: {
      fgColor: '#dc2626',
      bgColor: '#fef2f2',
    },
    suggestedType: 'url',
    placeholder: 'https://gymschedule.com'
  },
  {
    id: 'minimal',
    name: 'Minimal Black',
    category: 'Classic',
    description: 'Clean and professional look',
    icon: '⚫',
    customization: {
      fgColor: '#000000',
      bgColor: '#ffffff',
    },
    suggestedType: 'url',
    placeholder: 'https://example.com'
  },
  {
    id: 'vibrant',
    name: 'Vibrant Orange',
    category: 'Creative',
    description: 'Eye-catching and energetic',
    icon: '🟠',
    customization: {
      fgColor: '#ea580c',
      bgColor: '#fff7ed',
    },
    suggestedType: 'url',
    placeholder: 'https://example.com'
  },
  {
    id: 'professional',
    name: 'Professional Navy',
    category: 'Corporate',
    description: 'Trustworthy corporate style',
    icon: '🔵',
    customization: {
      fgColor: '#0f172a',
      bgColor: '#f8fafc',
    },
    suggestedType: 'url',
    placeholder: 'https://example.com'
  }
];

export const getTemplatesByCategory = () => {
  const categories = {};
  qrTemplates.forEach(template => {
    if (!categories[template.category]) {
      categories[template.category] = [];
    }
    categories[template.category].push(template);
  });
  return categories;
};
